export default {
    state: () => ({
        galleryItems: [],
		displayManufacturerLogo: false,
    }),
    getters: {
        getGalleryItems: (state) => {
            return state.galleryItems;
        },
		getDisplayManufacturerLogo: (state) => {
			return state.displayManufacturerLogo;
		},
    },
    mutations: {
        setGalleryItems: (state, items) => {
            state.galleryItems = items;
        },
		setDisplayManufacturerLogo: (state, value) => {
			state.displayManufacturerLogo = value;
		},
    },
}
